const initialState = {
  activeMenuLabel: "",
};

export const uiReducer = (state = initialState, action) => {
  if (action.type === "SET_ACTIVE_MENU_LABEL") {
    return { ...state, activeMenuLabel: action.payload };
  }
  return state;
};

export const setActiveMenuLabel = (label) => ({
  type: "SET_ACTIVE_MENU_LABEL",
  payload: label,
});
